import set from 'lodash/set';
import get from 'lodash/get';
import {
  FETCH_DEPLOYMENT_REPORT,
  FETCH_DEPLOYMENT_EVENTS,
  FETCH_REPAIR_TICKET_REPORT,
  FETCH_REPAIR_TICKETS_FOR_AGGREGATION_REPORT,
  FETCH_INVENTORY_REPORT,
  IS_LOADING,
  IS_REPORT_CSV_LOADING,
  FETCH_RIDE_REPORT,
} from '../actions/reports';

export default function(state = {}, action) {
  switch (action.type) {
    case FETCH_DEPLOYMENT_EVENTS: {
      /*
       set state with query data to avoid view re-renders which reset component state
       those re-renders would clear out input fields like date & market but still load the last shown report
      */
      const newState = { ...state };
      const marketId = get(action, 'payload.query.market_id', '');
      const dateFrom = get(action, 'payload.query.dateFrom', 0);
      const dateTo = get(action, 'payload.query.dateTo', 0);

      set(newState, `deploymentEvents.${marketId}${dateFrom}${dateTo}`, action.payload.reports);

      return newState;
    }
    case IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case IS_REPORT_CSV_LOADING:
      return {
        ...state,
        isReportCsvLoading: action.payload,
      };
    case FETCH_DEPLOYMENT_REPORT: {
      const newState = {};
      ({ ...state });
      set(newState, `deploymentReport.${action.payload.marketId}${action.payload.date.format('x')}`, action.payload.tasks);
      return newState;
    }
    case FETCH_RIDE_REPORT: {
      const newState = { ...state };
      set(newState, 'rides', action.payload);
      return newState;
    }
    case FETCH_REPAIR_TICKET_REPORT: {
      const newState = { ...state };
      set(newState, 'repairTickets', action.payload);
      return newState;
    }
    case FETCH_REPAIR_TICKETS_FOR_AGGREGATION_REPORT: {
      const newState = { ...state };
      set(newState, 'repairTicketsForAggregation', action.payload);
      return newState;
    }
    case FETCH_INVENTORY_REPORT: {
      const newState = { ...state };
      set(newState, 'inventoryEvents', action.payload);
      return newState;
    }
    default:
      return state;
  }
}
